import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { getOptimisticCartDelta } from "@thkStore/Common/Utilities/optimisticCartCount";

/**
 * Optimistically bumps the header cart badge the instant a single add-to-cart succeeds,
 * so it doesn't wait for the awaited full cart reload (pricing/shipping/promotions) that
 * follows. The delta is reset when the real cart finishes loading (see
 * OptimisticCartCountReducer), so the badge always reconciles to the authoritative count.
 *
 * Runs after SendDataToApi (which returns false on failure, stopping the chain) and before
 * LoadCart, so it only applies on a successful add.
 *
 * Hooked here via addToChainAfter rather than an Overrides/ file because client-framework
 * handler chains are NOT replaced by the blueprint Overrides mechanism.
 */
const DispatchOptimisticCount: typeof SendDataToApi = props => {
    const cart = getCurrentCartState(props.getState()).value;
    const delta = getOptimisticCartDelta(cart, [
        { productId: props.parameter.productId, qtyOrdered: props.parameter.qtyOrdered },
    ]);
    if (delta > 0) {
        props.dispatch({
            type: "Cart/OptimisticCount/Add",
            delta,
        });
    }
};

addToChainAfter(chain, SendDataToApi, DispatchOptimisticCount);

if (module.hot) {
    module.hot.accept();
    const snapshotChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        snapshotChain.forEach(o => chain.push(o));
    });
}
